<template>
  <a-layout-footer class='footer'> <a href="https://hebeigaoda.com" style="font-size:12px; color:#666; margin-top:15px;">
            &copy; 2025 高大永恒塑料制品有限公司. 保留所有权利.<br>
            ICP备案号：冀ICP备2026022338号-1
        </a></a-layout-footer>
</template>
<script>
export default {
  name: "AppFooter",
  props: {},
  data() {
    return {};
  },
};
</script>